<app-shell scrollSpy (navSize)="shrinkNav($event)" [navbarHeight]="ypos">
  <router-outlet></router-outlet>
</app-shell>